import React from 'react';

const RatingCard = ({ 
  title = "Ratings", 
  subtitle = "Graph 1", 
  value = "12.07", 
  rating = 12.07, 
  maxRating = 100,
  color = "orange",
  className = "" 
}) => {
  // Calculate bar height as percentage of max rating
  const barHeight = (rating / maxRating) * 100;
  
  // Color variants
  const colorVariants = {
    orange: {
      bar: 'bg-orange-400',
      legend: 'bg-orange-400',
      text: 'text-orange-600'
    },
    blue: {
      bar: 'bg-blue-400',
      legend: 'bg-blue-400',
      text: 'text-blue-600'
    },
    green: {
      bar: 'bg-green-400',
      legend: 'bg-green-400',
      text: 'text-green-600'
    },
    red: {
      bar: 'bg-red-400',
      legend: 'bg-red-400',
      text: 'text-red-600'
    }
  };

  const selectedColor = colorVariants[color] || colorVariants.orange;

  return (
    <div 
      className={`bg-white border border-gray-200 ${className}`}
      style={{
        width: '343px',
        height: '349px',
        borderRadius: '8px',
        borderWidth: '1px',
        padding: '16px',
        gap: '16px',
        opacity: 1
      }}
    >
      {/* Header */}
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-1">{title}</h3>
        <p className="text-sm text-gray-600">{subtitle}</p>
      </div>
      
      {/* Graph Area */}
      <div className="relative h-32 bg-gray-50 rounded mb-4">
        {/* Y-axis labels and grid lines */}
        <div className="absolute left-0 top-0 bottom-0 w-8 flex flex-col justify-between text-xs text-gray-400">
          <span>100</span>
          <span>80</span>
          <span>60</span>
          <span>40</span>
          <span>20</span>
          <span>0</span>
        </div>
        
        {/* Grid lines */}
        <div className="absolute left-8 right-0 top-0 bottom-0">
          {[0, 20, 40, 60, 80, 100].map((value, index) => (
            <div 
              key={value}
              className="absolute w-full border-t border-dotted border-gray-300"
              style={{ top: `${(100 - value)}%` }}
            ></div>
          ))}
        </div>
        
        {/* Bar Chart */}
        <div className="absolute left-8 right-0 top-0 bottom-0 flex items-end justify-center">
          <div 
            className={`w-8 ${selectedColor.bar} rounded-t`}
            style={{ height: `${barHeight}%` }}
          ></div>
        </div>
        
        {/* X-axis label */}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-6">
          <span className="text-xs text-gray-600">{value}</span>
        </div>
      </div>
      
      {/* Legend */}
      <div className="flex items-center justify-center">
        <div className={`w-3 h-3 ${selectedColor.legend} rounded mr-2`}></div>
        <span className={`text-sm ${selectedColor.text}`}>
          {title.includes("Ratings") ? "Rating" : "Average"} {rating}
        </span>
      </div>
    </div>
  );
};

export default RatingCard;
